import { combineReducers } from 'redux';

import monthlyClaimForm from './report/reducer';

export default combineReducers({
  monthlyClaimForm,
});



// WEBPACK FOOTER //
// ./src/pages/monthlyclaimform/state/reducer.js